module.exports = __webpack_public_path__ + "static/media/ladyoflourdes.cc83af5a.webp";